import { DesignSystemFontWeightMap } from 'src/lib/design-system/typography';

export const makeStatCardNodes = (sys) => {
  return {
    h3: {
      variant: 'h1',
      component: 'h2',
      fieldId: 'body',
    },
    p: {
      variant: 'h5',
      component: 'p',
      fieldId: 'body',
      style: {
        width: '100%',
      },
    },
    asset: {
      queryString: {
        xs: '?fm=webp&q=60',
        sm: '?fm=webp&q=60',
        md: '?fm=webp&q=60',
        lg: '?fm=webp&q=60',
      },
      width: 76,
      height: 80,
      sys: sys,
    },
  };
};

// Regular and SemiBold registry pairs differ only in weight, so setting
// <b>/<strong> to the SemiBold weight renders the SemiBold style exactly.
// On the already-SemiBold headings, bold becomes a no-op instead of a 700
// weight the registry does not have.
const semiBoldMarkSx = {
  '& b, & strong': {
    fontWeight: DesignSystemFontWeightMap.SemiBold,
    fontFamily: 'inherit',
  },
};

// Text-node mapping shared by every imageCard renderer (CmsImageCards and
// TabbedCardsSection). Keep it shared: the paired migration rewrites every
// imageCard entry, so a renderer with its own map silently drops nodes it
// does not know. Heading 5 renders smaller than normal text because the
// migration rewrites pre-mapping headings (Small Headline) to heading 2 and
// body copy pairs with P1 Regular per the Figma spec. Heading 6 stays free
// for the spec's hidden eyebrow layer.
export const imageCardTextNodes = {
  h2: {
    variant: 'Small Headline',
    theme: 'web 3.0',
    component: 'h3',
    fieldId: 'body',
    sx: semiBoldMarkSx,
  },
  h3: {
    variant: 'Subhead SemiBold',
    theme: 'web 3.0',
    component: 'h3',
    fieldId: 'body',
    sx: semiBoldMarkSx,
  },
  h5: {
    variant: 'P2 Regular',
    theme: 'web 3.0',
    component: 'p',
    fieldId: 'body',
    sx: semiBoldMarkSx,
  },
  p: {
    variant: 'P1 Regular',
    theme: 'web 3.0',
    component: 'p',
    fieldId: 'body',
    sx: semiBoldMarkSx,
  },
};

export const makeImageCardNodes = (fields) => {
  return {
    ...imageCardTextNodes,
    asset: {
      queryString: {
        xs: '?fm=webp&w=664&q=60',
        sm: '?fm=webp&w=1080&q=60',
        md:
          fields?.imageCards?.length === 3
            ? '?fm=webp&w=602&q=60'
            : '?fm=webp&w=772&q=60',
        lg:
          fields?.imageCards?.length === 3
            ? '?fm=webp&w=800&q=60'
            : '?fm=webp&w=1220&q=60',
      },
      width: fields?.imageCards?.length === 3 ? 540 : 610,
      height: fields?.imageCards?.length === 3 ? 480 : 460,
    },
  };
};

export const parallaxCardNodes = {
  h3: {
    variant: 'h4',
    component: 'h3',
  },
  p: {
    variant: 'p',
  },
};
